// extracted by mini-css-extract-plugin
module.exports = {"indicator":"alertIndicator-module--indicator--3yJmc","alertDot":"alertIndicator-module--alertDot--1xzYa"};